import clsx from 'clsx';

import type { FCCCN } from '../../types';

export const SummarySection: FCCCN = ({ children, className }) => {
    return <div className={clsx('flex flex-col space-y-2', className)}>{children}</div>;
};